import ActivityContainer from "../components/MyTask/ActivityContainer";
import MyTasksTable from "../components/MyTask/MyTasksTable";

function MyTasks(props: any) {
	return (
		<div className="generic-container" style={{ overflow: "auto" }}>
			<div className="flex gap-4 h-full w-full">
				<div className="flex flex-col flex-2 rounded-sm overflow-hidden relative bg-[var(--side-container-bg)]">
					<div className="w-full h-14 min-h-14 relative">
						<div className="rounded-br-4xl rounded-tl-sm bg-[var(--default-btn-color)] text-[var(--default-btn-text-color)] shadow-[0_0_6px_0_rgba(0,0,0,0.30)] p-0 px-4 flex h-14 items-center justify-center gap-2 top-0 left-0 text-sm absolute">
							Outstanding tasks
						</div>
					</div>

					<MyTasksTable />
				</div>

				{/***
				 * To be added later
				 */}
				{/* <ActivityContainer /> */}
			</div>
		</div>
	);
}

export default MyTasks;
